import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const SingleLoginActivityDetails = () => {
  const { loginActivityId } = useParams();
  const decodedId = loginActivityId ? atob(loginActivityId) : loginActivityId;
  const id = decodedId.replace(/\D/g, ''); // Ensure we only get the numeric part
  const [loginActivityDetails, setLoginActivityDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {
    fetchLoginActivityDetails();
  }, [loginActivityId]);

  const fetchLoginActivityDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.login_activity}${id}/`, { headers });
      const extractedColumns = [...Object.keys(response.data)];
      const excludedColumns = ['id', 'created_at', 'updated_at', 'user'];

      const columnsArray = [...extractedColumns]
        .filter((column) => !excludedColumns.includes(column))
        .map((column) => {
          return {
            label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
            field: column,
          };
        });

      setColumnDetails(columnsArray);
      setLoginActivityDetails(response.data);
    } catch (error) {
      console.error('Error fetching login activity details:', error);
    }
  };

  return (
    <div>
      {loginActivityDetails ? (
        <SingleItemDetailTemplate details={loginActivityDetails} columns={columns} />
      ) : (
        <p>Loading login activity details...</p>
      )}
    </div>
  );
};

export default SingleLoginActivityDetails;